export { default } from 'features/menu/routes/menu-section-route';
